jQuery(document).ready(function() {
    jQuery('#partenaire_oui').on('click', function() {
        jQuery("select#destinataire").val('').change();
        jQuery("select#destinataire").prop('disabled', false);
        jQuery("select#destinataire").prop('required', true);
    })
    jQuery('#partenaire_non').on('click', function() {
        jQuery("select#destinataire ").val('2').change();
        jQuery('select#destinataire option[value="2"]').attr('selected', 'selected');
        jQuery("select#destinataire").prop('disabled', 'disabled');
    })
    
    const $suite = $('.area-next');
    const $btnMore = $('.btn_more');
    $suite.slideUp();
    // Add a click event listener to the button
    $btnMore.on('click', function(e) {
        // Prevent the default action of the link
        e.preventDefault();
        
        $suite.slideToggle();
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
            $(this).text('Voir moins ↑');
            
        } else {
            $(this).text('Voir plus ↓');
        }
    });
});